/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import { styled } from '@mui/material';
import { TestIds } from '../../testIds';
import { Button } from '../Button';
import DropdownList from '../Dropdownlist';

const TopContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: 1,
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '8px',
  [theme.breakpoints.down('sm')]: {
    alignItems: 'center',
  },
}));

const PaginationWrapper = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '16px',
});

const DropdownlistWrapper = styled('div')({
  minWidth: '252px',
});

interface PaginationDetailProps {
  onClear: () => void;
  showClear?: boolean;
  paginationCounter?: React.ReactNode;
  sorting?: { value: string; options: string[]; onChange: (option: string) => void };
}

export const PaginationDetails: React.FC<PaginationDetailProps> = ({
  paginationCounter,
  showClear,
  onClear,
  sorting,
}) => {
  return (
    <TopContainer>
      <PaginationWrapper>
        {paginationCounter}
        {showClear && (
          <Button
            data-testid={`${TestIds.components.pagination.clearFilterButton}`}
            variant='underline'
            onClick={() => {
              sorting?.onChange(sorting.options[0]);
              onClear();
            }}
          >
            Clear filters
          </Button>
        )}
      </PaginationWrapper>
      {sorting && (
        <DropdownlistWrapper>
          <DropdownList
            items={sorting.options.map((x) => {
              return { value: x, disabled: false };
            })}
            label='Sort by: '
            labelposition='left'
            labelfontweight={400}
            value={sorting.value}
            onChange={(e) => sorting.onChange(e.target.value)}
            testId={TestIds.components.pagination.sortingDropdown}
          />
        </DropdownlistWrapper>
      )}
    </TopContainer>
  );
};

export default PaginationDetails;
